import { Component,Input,OnInit } from '@angular/core';
import * as Handlebars from 'handlebars/dist/cjs/handlebars';

@Component({
  selector: 'app-dynamic-template',
  //template: '<div class="col-md-12" *ngIf="html" [innerHTML]="html | safe:\'html\'"></div>'
  templateUrl: './dynamic-template.component.html',
})
export class DynamicTemplateComponent implements OnInit {

  @Input() template: string;
  html: string;
  t: any;
  
  constructor() { }

  set(data: any){
    //var input = new Handlebars.SafeHtml(data);
    this.html = this.t(data);    
    //console.log(this.html);
  }

  ngOnInit(): void {
    if (this.t == null) {
      this.t = Handlebars.compile(this.template);
    }
    // default the HTML to the template in case no data is ever loaded.
    this.set(null);
  }
}
